type ErrorBannerProps = {
  message: string;
};

/** Surfaces a backend error message as-is; the API already sends Spanish copy. */
export function ErrorBanner({ message }: ErrorBannerProps) {
  return (
    <p role="alert" className="error-banner">
      {message}
    </p>
  );
}
